import { createSlice } from "@reduxjs/toolkit";

const membersSlice = createSlice({
  name: "members",
  initialState: {
    members: [],
    message: { SummaryList: [], TotalCount: 0 },
    requestMember: { RequestList: [], TotalCount: 0 },
  },
  reducers: {
    setMembers: (state, action) => {
      state.members = action.payload;
    },
    setMessage: (state, action) => {
      state.message = action.payload || { SummaryList: [], TotalCount: 0 };
    },
    addMessage: (state, action) => {
      const newMessage = action.payload;
      if (!state.message.SummaryList) {
        state.message.SummaryList = [];
      }
      state.message.SummaryList.unshift(newMessage);
      state.message.TotalCount += 1;
    },
    addRequest: (state, action) => {
      const newRequest = action.payload;
      if (!state.requestMember.RequestList) {
        state.requestMember.RequestList = [];
      }
      state.requestMember.RequestList.unshift(newRequest);
      state.requestMember.TotalCount += 1;
    },
    setRequest: (state, action) => {
      state.requestMember = action.payload || { RequestList: [], TotalCount: 0 };
    },
    
    setReimbursementRequest: (state, action) => {
      state.requestMember = action.payload || { RequestList: [], TotalCount: 0 };
    },
    
    UpdateRequest: (state, action) => {
      const { Id, Status } = action.payload;
      const request = state.requestMember.RequestList.find(item => item.Id === Id);
      if (request) {
        request.RequestStatus = Status;
      }
    },
    UpdateBreakSocket: (state, action) => {
      const { Id, BreakType, BreakReason } = action.payload;
      const memupdate = state.members.find(item => item.Id === Id);
      if (memupdate) {
        memupdate.BreakType = BreakType;
        memupdate.BreakReason = BreakReason;
      }
    },

  },
});

export const { setMembers, setMessage, addMessage, addRequest, setRequest, UpdateRequest, UpdateBreakSocket ,setReimbursementRequest} = membersSlice.actions;
export default membersSlice.reducer;
